module.exports = __webpack_public_path__ + "img/alarm-screen.d35522e7.svg";